import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';

// API
import * as API  from '../../utils/api';

// Components
import Header from '../../components/Global/Header';
import Footer from '../../components/Global/Footer';
import AppCanvasLoader from '../../components/Global/AppCanvasLoader';
import CoachProfileViewsIndicator from '../../components/Global/CoachProfileViewsIndicator';

// Actions
import {
  updateActiveProfile
} from '../../actions/activeProfile'

// Utils
import { isAdmin } from '../../utils/auth';

class Coach extends Component {
  state = {
    coach: {},
    coachDataIsLoading: true,
    isAdmin: false,
    trialInfoLoading: true,
    trial_info: {
      on_trial: null,
      trial_active: null,
      days_remaining: null,
      trial_expired: null,
      trial_coach_views: null,
    },
    trialViewsRemaining: 0,
  }

  componentDidMount() {
    const coachId = this.props.match.params.coachId;
    const { user } = this.props;

    this.initializeCoachPage(coachId)

    if (isAdmin(user)) {
      this.setState({ isAdmin: true })
    } else {
      this.setTrialInfo();
    }
  }

  setTrialInfo = () => {
    const { activeProfile } = this.props;
    const trialViewsRemaining = activeProfile.trial_info.trial_active ? activeProfile.trial_info.trial_coach_views - 1 : 0;

    this.setState({
      trialCanAccessResult: ( activeProfile.trial_info.trial_active && activeProfile.trial_info.trial_coach_views > 0 ),
      trialViewsRemaining,
      trial_info: activeProfile.trial_info,
      trialInfoLoading: false,
    }, () => {
      const { trial_active } = this.state.trial_info;
      if ( trial_active ) {
        this.updateTrialCoachViews()
      }
    });
  }

  renderUserInitials = (coach) => {
    return `${coach.first_name.charAt(0)}${coach.last_name.charAt(0)}`;
  }

  initializeCoachPage(coachId) {
    const { user } = this.props;

    API.getCoach(user, coachId).then(coach => {
      this.setState({
        coach: coach,
        coachDataIsLoading: false
      })
    })
  }

  updateTrialCoachViews() {
    const { activeProfile, user } = this.props;

    API.updateTrialCoachViews(user, activeProfile.username).then(response => {
      const previousCoachViewsRemaining = activeProfile.trial_info.trial_coach_views

      if(previousCoachViewsRemaining === 1) {
        this.setState({
          isLastCoachView: true
        })
      }

      let updatedActiveProfile = { ...activeProfile }
      updatedActiveProfile.trial_info.trial_coach_views = previousCoachViewsRemaining > 0
      ? previousCoachViewsRemaining - 1
      : 0

      this.props.updateActiveProfile(user, activeProfile.username, updatedActiveProfile);
    });
  }

  returnSportGender(gender) {
    switch(gender) {
      case 'M':
        return "Men's";
        // eslint-disable-next-line no-unreachable
        break;
      case 'W':
        return "Women's";
        // eslint-disable-next-line no-unreachable
        break;
      case 'C':
        return "Coed";
        // eslint-disable-next-line no-unreachable
        break;
      default:
        return "";
        // eslint-disable-next-line no-unreachable
        break;
    }
  }

  render() {
    const {
      path,
      appName,
      user,
    } = this.props;

    const {
      coach,
      coachDataIsLoading,
      isLastCoachView,
      trial_info,
      trialViewsRemaining,
      trialInfoLoading,
      isAdmin,
    } = this.state;

    if (trialInfoLoading && !isAdmin) {
      return null;
    }

    const { isLoggedIn, reduxLogInComplete, paid_content } = user;
    const { trial_active, on_trial } = trial_info;

    if (isLoggedIn && !reduxLogInComplete) {
      return <Redirect to={{ pathname: '/log-in' }}/>
    } else if ((!trial_active || trialViewsRemaining <= 0) && !isLastCoachView && !paid_content) {
      return <Redirect to={{ pathname: '/' }} />
    } else if (isLoggedIn && reduxLogInComplete) {
      return (
        <div>
          <Header path={ path } />
          {
            coachDataIsLoading
            ? (
              <div className="dashboard-loader-container">
                <AppCanvasLoader />
              </div>
            ) : (
              <section className="coach-profile">
                <div className="inner-wrap">
                  { on_trial &&
                    <CoachProfileViewsIndicator remainingCoachProfileViews={trialViewsRemaining}/>
                  }
                </div>
                <div className="inner-wrap">
                  <div className="coach-profile-container">
                    <div className="coach-profile-overview">

                      <div className="coach-profile-overview-name">
                        <div className="initial">
                          <div className="initial-inner">
                            {this.renderUserInitials(coach)}
                          </div>
                        </div>
                        <h2>{`${coach.first_name} ${coach.last_name}`}</h2>
                      </div>

                      <div className="coach-profile-overview-contact">
                        <div className="info-container">
                          <h5>Email Address</h5>
                          <p>{coach.email}</p>
                        </div>
                        <div className="info-container">
                          <h5>Phone Number</h5>
                          <p>{coach.phone_number}</p>
                        </div>
                        { coach.fax_number ? (
                          <div className="info-container">
                            <h5>Fax Number</h5>
                            <div>{coach.fax_number}</div>
                          </div>
                        ) : ( null )}
                      </div>

                      <div className="coach-profile-overview-positions">
                        <h3>Positions</h3>
                        { coach.cd_jobs.map((job, index) => (
                          <div className="coach-profile-overview-positions-index" key={index}>
                            <div className="info-container">
                              <h5>Title</h5>
                              <p>{job.title}</p>
                            </div>
                            <div className="info-container">
                              <h5>Sport</h5>
                              <p>{`${job.cd_program.sport} (${this.returnSportGender(job.cd_program.gender)})`}
                              </p>
                            </div>
                            <div className="info-container">
                              <h5>Division</h5>
                              <p>{job.cd_program.division}</p>
                            </div>
                            <div className="info-container">
                              <h5>Conference</h5>
                              <p>{job.cd_program.conference}</p>
                            </div>
                          </div>
                        )) }
                      </div>
                    </div>

                    <div className="coach-profile-university">
                      <h2>{coach.cd_school.name}</h2>
                      <div className="coach-profile-university-info">
                        <div className="info-container">
                          <h5>Address</h5>
                          <p>
                            {coach.cd_school.address_primary}
                            { coach.cd_school.address_secondary ? (
                              <span>{coach.cd_school.address_secondary}</span>
                            ) : ( null )}
                          </p>
                        </div>
                        <div className="info-container">
                          <h5>City</h5>
                          <p>{coach.cd_school.city}</p>
                        </div>
                        <div className="info-container">
                          <h5>State</h5>
                          <p>{coach.cd_school.state}</p>
                        </div>
                        <div className="info-container">
                          <h5>Zip Code</h5>
                          <p>
                            {coach.cd_school.zipcode}
                            { coach.cd_school.zip_plus ? (
                              <span>-{coach.cd_school.zip_plus}</span>
                            ) : ( null )}
                          </p>
                        </div>
                        <div className="info-container">
                          <h5>Phone Number</h5>
                          <p>{coach.cd_school.phone_number}</p>
                        </div>
                        { coach.cd_school.address_secondary ? (
                          <div className="info-container">
                            <h5>Fax Number</h5>
                            <div>{coach.cd_school.fax_number}</div>
                          </div>
                        ) : ( null )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="inner-wrap buttons">
                  <Link className="cta" to="/">New Search</Link>
                  <button className="cta" onClick={this.props.history.goBack}>
                    Back to Results
                  </button>
                </div>
              </section>
            )
          }
          <Footer appName={ appName } path={ path } />
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    activeProfile: state.activeProfile,
    user: state.user
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateActiveProfile: (user, username, profile) => dispatch(updateActiveProfile(user, username, profile))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Coach)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Coach.js